/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
 */

import React from 'react'
import { Dialog, CircularProgress } from 'material-ui'

class LoadingDialog extends React.Component {
  render () {
    return (
      <Dialog
        modal={true}
        open={true}
        overlayStyle={styles.overlayStyle}
        paperProps={{
          style:styles.paperProps
        }}
        contentStyle={styles.contentStyle}
        style={styles.dialogStyle}
      >
        {this.props.message || ''}

        <CircularProgress 
          size={300} 
          color={this.props.loadingColor || 'white'}
        />
      </Dialog>
    )
  }
}

const styles = {
  overlayStyle: {
    backgroundColor: '#262626', 
    opacity: 0.9
  },
  contentStyle: {
    position: 'relative', 
    transform: 0, 
    width: '100%', 
    maxWidth: '100%',
    textAlign: 'center',
  },
  dialogStyle: {
    alignItems: 'center', 
    justifyContent: 'center', 
    paddingTop: 0,
  },
  paperProps: {
    backgroundColor: 'transparent',
    boxShadow: 'initial',
  },
}

export default LoadingDialog



// WEBPACK FOOTER //
// ./src/generic/dialog/LoadingDialog.js